
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class TestResultMuteDialog extends Serenity.EntityDialog<TestResultMuteRow, any> {
        protected getFormKey() { return TestResultMuteForm.formKey; }
        protected getIdProperty() { return TestResultMuteRow.idProperty; }
        protected getLocalTextPrefix() { return TestResultMuteRow.localTextPrefix; }
        protected getNameProperty() { return TestResultMuteRow.nameProperty; }
        protected getService() { return TestResultMuteService.baseUrl; }

        protected form = new TestResultMuteForm(this.idPrefix);

    }
}